





















































































import { Component, Vue } from 'vue-property-decorator';
import firebase from "firebase";
import AppLayout from "@/components/AppLayout.vue";

@Component({
  components: { AppLayout }
})
export default class Profile extends Vue {
  private user: any = null;
  private showMessage = false;
  private showUpdatePassword = false;
  private showUpdateProfile = false;
  private loading = false;
  private password = '';
  private newPassword = '';
  private message = '';
  private userDisplayName = '';
  private userEmail = '';

  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        if (user.displayName) this.userDisplayName = user.displayName;
        if (user.email) this.userEmail = user.email;
      }
    });
  }

  updateProfile() {
    this.loading = true;
    firebase
      .auth()
      .signInWithEmailAndPassword(this.user.email, this.password)
      .then(() => this.user.updateProfile({displayName: this.userDisplayName}))
      .then(() => this.user.updateEmail(this.userEmail))
      .then(() => {
        this.showMessage = true;
        this.message = "Perfil actualizado correctamente"
        this.showUpdateProfile = false;
        this.loading = false;
      })
      .catch((error: any) => {
        this.message = 'Ha ocurrido un error. intenta nuevamente.';
        if (error.code == 'auth/wrong-password') this.message = 'Contraseña incorrecta';
        this.showMessage = true;
        this.loading = false;
      });
  }

  updatePassword() {
    this.loading = true;
    firebase
      .auth()
      .signInWithEmailAndPassword(this.user.email, this.password)
      .then(() => this.user.updatePassword(this.newPassword))
      .then(() => {
        this.showMessage = true
        this.message = "Contraseña actualizada correctamente"
        this.showUpdatePassword = false;
        this.loading = false;
      })
      .catch((error: any) => {
        this.message = 'Ha ocurrido un error. intenta nuevamente.';
        if (error.code == 'auth/wrong-password') this.message = 'Contraseña incorrecta';
        this.showMessage = true;
        this.loading = false;
      });
  }
}
